import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";
import getLeads from "../../services/getLeads";
import getTag from "../../services/getTag";
import deleteLeads from "../../services/deleteLeads";
import getCategorieTag from "../../services/getCategorieTag";

export default class Chiamati extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];
    this.selectRef = React.createRef();

    // Recupera i filtri salvati dal localStorage
    const getSavedFilters = () => {
      try {
        const savedSelectedTags = localStorage.getItem("chiamati_selectedTags");
        const savedExcludedTags = localStorage.getItem("chiamati_excludedTags");
        const savedDataInizio = localStorage.getItem("chiamati_dataInizio");
        const savedDataFine = localStorage.getItem("chiamati_dataFine");

        const filters = {
          selectedTags: savedSelectedTags ? JSON.parse(savedSelectedTags) : [],
          excludedTags: savedExcludedTags ? JSON.parse(savedExcludedTags) : [],
          dataInizio: savedDataInizio ? JSON.parse(savedDataInizio) : null,
          dataFine: savedDataFine ? JSON.parse(savedDataFine) : null,
        };

        console.log(
          "🔄 Chiamati - Filtri recuperati dal localStorage:",
          filters
        );
        return filters;
      } catch (e) {
        console.error("❌ Chiamati - Errore nel recupero dei filtri:", e);
        return {
          selectedTags: [],
          excludedTags: [],
          dataInizio: null,
          dataFine: null,
        };
      }
    };

    const savedFilters = getSavedFilters();

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: [],
      leads: [],
      selectedTags: savedFilters.selectedTags,
      excludedTags: savedFilters.excludedTags,
      dataInizio: savedFilters.dataInizio,
      dataFine: savedFilters.dataFine,
      studenti: [],
    };

    this.grid = 2;
    this.pdfElements = [];
    this.studenti = [];
    this.pageTitle = "Chiamati";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({ list: [] });
    cookies.set("checksList", strJson, { path: "/" });

    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.tags = [];
  }

  handleTagChange = (selectedTags) => {
    console.log("💾 Chiamati - Salvataggio selectedTags:", selectedTags);
    localStorage.setItem("chiamati_selectedTags", JSON.stringify(selectedTags));
    this.setState({ selectedTags: selectedTags }, () => {
      this.reload();
    });
  };

  handleDataInizioChange = (dataInizio) => {
    console.log("💾 Chiamati - Salvataggio dataInizio:", dataInizio);
    localStorage.setItem("chiamati_dataInizio", JSON.stringify(dataInizio));
    this.setState({ dataInizio: dataInizio }, () => {
      this.reload();
    });
  };

  handleDataFineChange = (dataFine) => {
    console.log("💾 Chiamati - Salvataggio dataFine:", dataFine);
    localStorage.setItem("chiamati_dataFine", JSON.stringify(dataFine));
    this.setState({ dataFine: dataFine }, () => {
      this.reload();
    });
  };

  handleTagRemoveChange = (removedTags) => {
    console.log("💾 Chiamati - Salvataggio excludedTags:", removedTags);
    localStorage.setItem("chiamati_excludedTags", JSON.stringify(removedTags));
    this.setState(
      {
        excludedTags: removedTags,
      },
      () => {
        this.reload();
      }
    );
  };

  handleResetFilters = () => {
    console.log("🧹 Chiamati - Reset completo di tutti i filtri e ordinamenti");
    // Pulisce tutti i filtri dal localStorage
    localStorage.removeItem("chiamati_selectedTags");
    localStorage.removeItem("chiamati_excludedTags");
    localStorage.removeItem("chiamati_dataInizio");
    localStorage.removeItem("chiamati_dataFine");
    localStorage.removeItem("chiamati_table_searchText");
    localStorage.removeItem("chiamati_table_order");
    localStorage.removeItem("chiamati_table_orderBy");
    localStorage.removeItem("chiamati_table_page");

    // Resetta i filtri nello stato
    this.handleTagChange([]);
    this.handleTagRemoveChange([]);
    this.handleDataInizioChange("");
    this.handleDataFineChange("");
  };

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const leads = await getLeads(username, token);
    this.tags = await getTag(username, token);
    this.category = await getCategorieTag(username, token);

    const findCategoryTags = this.category.map((category) => {
      const categoryTags = this.tags.filter(
        (tag) => tag.id_categoria === category.id
      );
      return {
        ...category,
        tags: categoryTags,
      };
    });

    const includeCategoryIds = [1, 5];

    const includeTagIds = findCategoryTags
      .filter((category) => includeCategoryIds.includes(category.id))
      .flatMap((category) => category.tags.map((tag) => tag.id));

    // Applica prima il filtro per includere solo le categorie specifiche (chiamati)
    const initialFilteredLeads = leads.filter((lead) => {
      const tagIds = lead.tag_id
        ? lead.tag_id.split(",").map((id) => parseInt(id))
        : [];
      const hasIncludedTag = tagIds.some((tagId) =>
        includeTagIds.includes(tagId)
      );
      return hasIncludedTag;
    });

    // Applica i filtri aggiuntivi (tag selezionati, tag esclusi, date)
    const filteredLeads = initialFilteredLeads.filter((lead) => {
      const tagIds = lead.tag_id
        ? lead.tag_id.split(",").map((tagId) => Number(tagId))
        : [];

      const dataModifica = lead.data_modifica
        ? new Date(lead.data_modifica)
        : null;

      // Filtro per data inizio
      if (this.state.dataInizio && dataModifica) {
        const dataInizio = new Date(this.state.dataInizio);
        if (dataModifica < dataInizio) {
          return false;
        }
      }

      // Filtro per data fine
      if (this.state.dataFine && dataModifica) {
        const dataFine = new Date(this.state.dataFine);
        if (dataModifica > dataFine) {
          return false;
        }
      }

      // Filtro per tag esclusi
      if (this.state.excludedTags && this.state.excludedTags.length > 0) {
        const excludedTagValues = this.state.excludedTags.map((tag) =>
          Number(tag.value)
        );
        if (tagIds.some((tagId) => excludedTagValues.includes(tagId))) {
          return false;
        }
      }

      // Filtro per tag selezionati (inclusivi)
      if (!this.state.selectedTags || this.state.selectedTags.length === 0) {
        return true;
      }

      return this.state.selectedTags.every((tag) =>
        tagIds.includes(Number(tag.value))
      );
    });

    // ✅ Ordina per data_modifica PRIMA della trasformazione per visualizzazione
    const sortedLeads = filteredLeads.sort((a, b) => {
      // Ordina per data_modifica in ordine decrescente (più recenti prima)
      const dateA = new Date(a.data_modifica || 0);
      const dateB = new Date(b.data_modifica || 0);
      return dateB - dateA;
    });

    const leadsWithTags = sortedLeads.map((lead) => {
      const tagIds = lead.tag_id ? lead.tag_id.split(",") : [];

      const tagNames = tagIds.map((tagId) => {
        const tag = this.tags.find((tag) => tag.id == tagId);
        return tag ? tag.tag : null;
      });

      const origineTags = [];
      const corsoTags = [];
      const infoDateTags = [];

      tagIds.forEach((tagId) => {
        const tag = this.tags.find((tag) => tag.id == tagId);
        if (tag) {
          const categoria = this.category.find(
            (categoria) => categoria.id == tag.id_categoria
          );
          if (categoria) {
            if (categoria.nome === "ORIGINE") {
              origineTags.push(tag.tag);
            } else if (categoria.nome === "CORSO") {
              corsoTags.push(tag.tag);
            } else if (categoria.nome === "INFO DATE") {
              infoDateTags.push(tag.tag);
            }
          }
        }
      });

      const dateOnly = lead.data_modifica
        ? lead.data_modifica.split(" ")[0]
        : "";
      const dataIscrizioneFormatted = lead.data_iscrizione
        ? lead.data_iscrizione.split(" ")[0]
        : "";

      return {
        ...lead,
        tag_name: tagNames.length > 0 ? tagNames.join(", ") : "Nessun tag",
        origine: origineTags.length > 0 ? origineTags.join(", ") : "",
        corso: corsoTags.length > 0 ? corsoTags.join(", ") : "",
        info_date: infoDateTags.length > 0 ? infoDateTags.join(", ") : "",
        data_modifica_display: dateOnly, // Per visualizzazione
        // Manteniamo data_modifica originale per ordinamento
        data_iscrizione: dataIscrizioneFormatted,
      };
    });

    this.setState({
      leads: leadsWithTags,
    });
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {
    var headCells = [
      {
        id: "data_modifica",
        numeric: false,
        disablePadding: false,
        label: "Ultima modifica",
      },
      { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      { id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
      {
        id: "telefono",
        numeric: true,
        disablePadding: false,
        label: "Telefono",
      },
      { id: "corso", numeric: true, disablePadding: false, label: "Corso" },
      { id: "origine", numeric: true, disablePadding: false, label: "Origine" },
      {
        id: "data_iscrizione",
        numeric: true,
        disablePadding: false,
        label: "Data iscrizione",
      },
      {
        id: "prenotazione",
        numeric: true,
        disablePadding: false,
        label: "Prenotazione",
      },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    this.searchCols = ["nome", "cognome", "mail", "telefono", "data_modifica"];

    const cookies = new Cookies();

    const formattedTags = this.tags.map((tag) => ({
      value: tag.id,
      label: tag.tag,
    }));

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle
            title={this.pageTitle}
            button="NUOVO"
            onClick={() => {
              window.location.href = "/#/app/addLead";
            }}
          />

          <Table
            storageKey="chiamati_table"
            headCells={headCells}
            searchCols={this.searchCols}
            desc
            assenze={false}
            calendar={false}
            onChangeDataInizio={this.handleDataInizioChange}
            onChangeDataFine={this.handleDataFineChange}
            dataInizio={this.state.dataInizio}
            dataFine={this.state.dataFine}
            filterTags={formattedTags}
            handleTagChange={this.handleTagChange}
            removeTags
            handleTagRemoveChange={this.handleTagRemoveChange}
            selectedTags={this.state.selectedTags}
            excludedTags={this.state.excludedTags}
            onResetFilters={this.handleResetFilters}
            pdf={false}
            excel={false}
            mail={false}
            phone={false}
            rows={this.state.leads}
            onEventClick={(row) => {
              cookies.set("currentCrm", row, { path: "/" });
              window.location.href = "/#/app/editLead";
            }}
            onPdfClicked={(row) => {
              cookies.set("requestedStudent", row, { path: "/" });
              window.location.href = "/#/app/pdfSingleStudent";
            }}
            onSendMail={(id) => {
              this.sendMailRef.current && this.sendMailRef.current.reset();
              this.setState({ sendMailVisible: true, sendMailUserId: id });
            }}
            onSendNotification={(id) => {
              this.sendNotificationRef.current &&
                this.sendNotificationRef.current.reset();
              this.setState({
                sendNotificationVisible: true,
                notificationUser: id,
              });
            }}
            onDelete={async (id) => {
              if (
                window.confirm("Sei sicuro di voler eliminare il lead?") ==
                false
              )
                return;

              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await deleteLeads(username, token, id);
              this.reload();
            }}
            onElementCheck={async (companyId) => {
              const cookies = new Cookies();

              var json = cookies.get("checksList", { path: "/" });
              var checksList = json.list;
              var index = checksList.indexOf(companyId);
              if (index != -1) checksList.splice(index, 1);
              else checksList.push(companyId);

              cookies.set("checksList", JSON.stringify({ list: checksList }), {
                path: "/",
              });
            }}
          />

          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
      </>
    );
  }
}
